import React from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../../assets/logo.png';
import {
  PUBLIC_SITE_LOGO_ALT,
  PUBLIC_PRIMARY_NAV_LINKS,
  PUBLIC_REGISTER_PATH,
  PUBLIC_LOGIN_PATH,
  PUBLIC_CARRIER_PASSPORT_URL,
  PUBLIC_CARRIER_PASSPORT_LABEL,
} from '../../constants/publicMarketingNav';
import styles from './PublicMarketingLayout.module.css';

const HEADER_TW =
  'tw-sticky tw-top-0 tw-z-[100] tw-shrink-0 tw-backdrop-blur-md tw-border-b tw-border-white/10 tw-bg-tz-navy/90';

const PublicSiteHeader: React.FC = () => (
  <header className={`${styles.header} ${HEADER_TW}`}>
    <div className={styles.logo}>
      <img
        src={logoImg}
        alt={PUBLIC_SITE_LOGO_ALT}
        className={styles.logoImg}
        loading="eager"
        width="200"
        height="50"
      />
      <div className={styles.textLogo}>
        <span className={styles.letterT}>T</span>
        <span className={styles.letterR}>R</span>
        <span className={styles.letterA}>A</span>
        <span className={styles.letterN}>N</span>
        <span className={styles.letterZ}>Z</span>
        <span className={styles.letterI}>I</span>
        <span className={styles.letterT2}>T</span>
      </div>
    </div>
    <nav className={styles.nav} aria-label="Primary">
      {PUBLIC_PRIMARY_NAV_LINKS.map(({ to, label }) => (
        <Link key={to} className={styles.menuLink} to={to}>
          {label}
        </Link>
      ))}
      <a className={styles.menuLink} href={PUBLIC_CARRIER_PASSPORT_URL}>
        {PUBLIC_CARRIER_PASSPORT_LABEL}
      </a>
      <Link className={`${styles.menuLink} ${styles.menuLinkCta}`} to={PUBLIC_REGISTER_PATH}>
        Register
      </Link>
      <Link className={styles.menuLink} to={PUBLIC_LOGIN_PATH}>
        Login
      </Link>
    </nav>
  </header>
);

export default PublicSiteHeader;
